import React, {useEffect, useRef, useState} from "react"
import CustomerNavbar from "../../../components/Navbars/CustomerNavbar"
import Shape from "../../../components/Shape"
import {Button, Col, Container, Row} from "reactstrap"
import SimpleFooter from "../../../components/Footers/SimpleFooter"
import {observer} from "mobx-react"
import Table, {Formatters} from '../../../components/Table'
import {useAppDataStore} from "../../../stores/appDataStore";

const Sessions = observer(({}) => {

  const [data, setData] = useState([])
  const appDataStore = useAppDataStore()

  useEffect(() => {
    refreshData()
  }, [])

  const columns = [
    {
      field: 'name',
      flex:1,
      headerName: 'Navegador'
    },
    {
      field: 'ip',
      headerName: 'IP',
    },
    {
      field: 'lastActivity',
      headerName: 'Ultima actividad',
      valueFormatter: Formatters.datetime

    },
    {
      field: 'createdAt',
      headerName: 'fecha creación',
      valueFormatter: Formatters.datetime

    },
    {
      field: '',
      flex: 1,
      maxWidth: 150,
      headerName: 'Cerrar sesiones',
      cellRenderer: ({data}) => {
        return <div className="action-icons">
          <Button size={"sm"} onClick={async () => {
            await appDataStore.closeSession(data.id)
            await refreshData()
          }}><i className={`p-0 ni ni-button-power text-danger`}/></Button>

        </div>
      }
    }
  ]

  const refreshData = async () => {
    try {
      let {sessions} = await appDataStore.getSessions()
      setData(sessions)
    } catch (err) {
      console.log(err)
    }
  }


  return (
    <div>
      <CustomerNavbar/>
      <main>
        <section className="section section-shaped section-lg">
          <Shape/>
          <Container className="py-lg-md">
            <Row>
              <Col lg={12} md={12}>
                <Table
                  tableName={'Sesiones'}
                  cols={columns}
                  rows={data}
                />
              </Col>
            </Row>
          </Container>
        </section>
      </main>
      <SimpleFooter/>
    </div>
  )
})

export default Sessions
